import React, { Component } from "react";
import axios from "../../util/axios";
import Alertmessage from '../../components/common/alertMessage';
import Field from '../../components/common/Field';
import { trackPromise } from "react-promise-tracker";

import { Validator } from "../../util/Validator";

class ChangePassword extends Component {

	constructor(props) {
		super(props);
		this.state = {
			oldPassword: "",
			newPassword: "",
			confirmNewPassword: "",
			displayErrorMessage: false
		};
		this.handleChange = this.handleChange.bind(this);
	}
	
	handleChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleChangePassword = async event => {
		event.preventDefault();
		const data = {};
		data.oldPassword = this.state.oldPassword;
		data.newPassword = this.state.newPassword;
		trackPromise(
			axios.put('api/user/changePassword', data, {
				headers: {
					Authorization: JSON.parse(localStorage.getItem("userData")).token,
					"Cobrand-Id": JSON.parse(localStorage.getItem("userData")).cobrands[0].id
				}
			})
			.then(res => {
				this.setState({ displayErrorMessage: false });
				var userData = JSON.parse(localStorage.getItem("userData"));
				if (userData.authentication && userData.authentication.tempPassword) {
					var authentication = userData.authentication;
					var tempPassword = {'tempPassword':false};
					var newAuthentication = Object.assign(authentication, tempPassword);
					var newUserData = JSON.stringify(Object.assign(userData, newAuthentication));
					localStorage.setItem("userData", newUserData);
				}
				window.location.href = "/";    
			})
			.catch(err => {
				if (err.response.data && err.response.data.errorMessage) {
					this.setState({ errorMessage: err.response.data.errorMessage });
				}
				this.setState({ displayErrorMessage: true });
			})
		);
	};	

	render() {
		return (
			<React.Fragment>					
				<div className="container main">
					<div className="row mt-4">
						<div className="col heading">Change Password</div>
					</div>
					{ this.props.prompt && 
						<div className="row mt-4 mb-2">
							<div className="col-md-6">
								<h6>{ this.props.prompt }</h6>
							</div>
						</div>
					}
					<div className="row mt-4 mb-2">
						<div className="col-md-5">
							<label>{ this.props.flow === "restricted" ? 'Enter Temporary Password' : 'Enter Old Password' }</label>
							<Field type="password" name="oldPassword" iconClass="fas fa-eye fa-1x pointer" iconBottom="25%" iconLeft="85%" value={this.state.oldPassword} onChange={this.handleChange} />
						</div>
					</div>
					<div className="row">
						<div className="col-md-5">
							<label>Enter New Password</label>
							<Field type="password" name="newPassword" className={Validator.isInvalidPassword(this.state.newPassword) ? "error" : ""} iconClass="fas fa-eye fa-1x pointer" iconBottom="25%" iconLeft="85%" value={this.state.newPassword} onChange={this.handleChange} />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-5 error">
							{ Validator.isInvalidPassword(this.state.newPassword) && <React.Fragment>{ Validator.passwordCriteria }</React.Fragment> }
						</div>
					</div>
					<div className="row">
						<div className="col-md-5">
							<label>Confirm New Password</label>
							<Field type="password" name="confirmNewPassword" className={Validator.isPasswordMismatch(this.state.newPassword, this.state.confirmNewPassword) ? "error" : ""} iconClass="fas fa-eye fa-1x pointer" iconBottom="25%" iconLeft="85%" value={this.state.confirmNewPassword} onChange={this.handleChange} />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-5 error">
							{ Validator.isPasswordMismatch(this.state.newPassword, this.state.confirmNewPassword) && <React.Fragment>{ Validator.passwordMatchError }</React.Fragment> }
						</div>
					</div>
					{ this.state.displayErrorMessage &&
						<div className="row mt-4">
							<div className="col-md-5 mx-n4">
								<Alertmessage message={this.state.errorMessage} alertType={'alert-danger'} />
							</div>
						</div>
					}
					<div className={this.state.displayErrorMessage ? 'row mt-2 mb-4' : 'row mt-4 mb-4'}>
						<div className="col-md-4">
							<button type="button" className="btn btn-primary" onClick={this.handleChangePassword} disabled={Validator.disableSubmitButton(this.state.newPassword, this.state.confirmNewPassword)}>Change Password</button>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default ChangePassword;